export const hostsKeys = {
  all: ['hosts'] as const,
  lists: () => [...hostsKeys.all, 'list'] as const,
  list: ({
    page,
    perPage,
    email,
    billingGroupId,
    destinationGroupId,
  }: {
    page: number;
    perPage: number;
    email?: string;
    billingGroupId?: string;
    destinationGroupId?: string;
  }) =>
    [
      ...hostsKeys.lists(),
      {
        page,
        perPage,
        email,
        billingGroupId,
        destinationGroupId,
      },
    ] as const,
  details: () => [...hostsKeys.all, 'details'] as const,
  detail: (hostId: number) => [...hostsKeys.details(), { hostId }] as const,
};
